import { Component, computed, input, output } from '@angular/core';

export type PaginacaoVariante = 'destaque' | 'simples';

@Component({
  selector: 'app-paginacao',
  templateUrl: './paginacao.component.html',
  styleUrls: ['./paginacao.component.css'],
})
export class PaginacaoComponent {
  readonly paginaAtual = input.required<number>();
  readonly totalPaginas = input.required<number>();

  readonly variante = input<PaginacaoVariante>('destaque');

  readonly rotulo = input('Paginação dos resultados');

  readonly resumo = input('');

  readonly paginaMudou = output<number>();

  readonly temPaginaAnterior = computed(() => this.paginaAtual() > 1);
  readonly temProximaPagina = computed(() => this.paginaAtual() < this.totalPaginas());

  readonly paginas = computed(() =>
    Array.from({ length: this.totalPaginas() }, (_, indice) => indice + 1)
  );

  paginaAnterior(): void {
    if (this.temPaginaAnterior()) {
      this.paginaMudou.emit(this.paginaAtual() - 1);
    }
  }

  proximaPagina(): void {
    if (this.temProximaPagina()) {
      this.paginaMudou.emit(this.paginaAtual() + 1);
    }
  }

  irParaPagina(pagina: number): void {
    if (pagina !== this.paginaAtual()) {
      this.paginaMudou.emit(pagina);
    }
  }
}
